// SPDX-License-Identifier: AGPL-3.0-or-later

import {CopyIdIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import * as TextCopyCommands from '@app/features/ui/commands/TextCopyCommands';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

interface CopyUserIdMenuItemProps {
	user: User;
	onClose: () => void;
}
export const CopyUserIdMenuItem: React.FC<CopyUserIdMenuItemProps> = observer(({user, onClose}) => {
	const {t, i18n} = useLingui();
	const handleCopyUserId = useCallback(() => {
		onClose();
		TextCopyCommands.copy(i18n, user.id, true);
	}, [user.id, onClose, i18n]);
	return (
		<MenuItem icon={<CopyIdIcon />} onClick={handleCopyUserId}>
			{t`Copy User ID`}
		</MenuItem>
	);
});
interface CopyRoleIdMenuItemProps {
	roleId: string;
	onClose: () => void;
}
export const CopyRoleIdMenuItem: React.FC<CopyRoleIdMenuItemProps> = observer(({roleId, onClose}) => {
	const {t, i18n} = useLingui();
	const handleCopyRoleId = useCallback(() => {
		onClose();
		TextCopyCommands.copy(i18n, roleId, true);
	}, [roleId, onClose, i18n]);
	return (
		<MenuItem icon={<CopyIdIcon />} onClick={handleCopyRoleId}>
			{t`Copy Role ID`}
		</MenuItem>
	);
});
